import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";

export const getInternalPath = (page?: string) => {
	return page ? asAbsolute(uploaderConsts.SOURCES.UNSPLASH, page) : asAbsolute(uploaderConsts.SOURCES.UNSPLASH);
};

export const getSelectedItemByValue = (value: string, options: { label: string, value: string }): Object => options.find((item) => item.value === value);

